export default "__VITE_ASSET__BIs56MFA__"